import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Box, Button, Card, CardContent, Container, Grid, Typography, Divider, Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../template/Footer";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import CloseIcon from '@mui/icons-material/Close';
import "./About.css";

const ForProviderPage = ({loader}) => {

    const { authInstance, authUser } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const handleImageClick = (src) => {
        setSelectedImage(src);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage('');
    };

    useEffect(() => {
        setLoaded(false);
        setError(null);
        setLoaded(true);
    },[authInstance, config.saas.permissions]);

    return (
        <>
            {loaded ? (
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="For Providers" />

                    <Box className="about-hero">
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Typography variant="h2" className="hero-title">For Providers</Typography>
                                    <Typography variant="h6" color="text.secondary" className="hero-sub">
                                        Be your own boss. Join the network of independent wellness professionals to earn 2-3x more than industry standards, when and wherever you want.
                                    </Typography>
                                    <Box sx={{ mt: 3 }}>
                                        <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={() => navigate('/sign-up')}>Sign Up</Button>
                                        <Button variant="outlined" color="secondary" onClick={() => navigate('/contact')}>Contact Us</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Box className="hero-art">
                                        <SupportAgentIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    <Container sx={{ py: 6 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <TrendingUpIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Higher Earnings</Typography>
                                        <Typography color="text.secondary">Earn 2-3x more than industry standards with flexible scheduling and premium rates.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <ScheduleIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Flexible Schedule</Typography>
                                        <Typography color="text.secondary">Work when and wherever you want with our platform's scheduling tools.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <VerifiedIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Verified Platform</Typography>
                                        <Typography color="text.secondary">Join a trusted network with verified clients and secure payments.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 6 }} />

                        <Typography variant="h4" align="center" sx={{ mb: 4 }}>
                            Simple Process
                        </Typography>

                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                            <img src="https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fagenda.png?alt=media&token=125c70f8-0767-4d4c-9863-22af3defc099" width="80%" alt="Agenda" onClick={() => handleImageClick('https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fagenda.png?alt=media&token=125c70f8-0767-4d4c-9863-22af3defc099')} style={{ cursor: 'pointer' }} />
                                        </Box>
                                        <Typography variant="h6" gutterBottom align="center">Manage Agenda</Typography>
                                        <Typography color="text.secondary" align="center">Easily organize your appointments and availability with our intuitive agenda system.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                            <img src="https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fappointment-map.png?alt=media&token=eaee1c6a-7865-4600-83cd-21c7356471e8" width="80%" alt="Appointment Map" onClick={() => handleImageClick('https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fappointment-map.png?alt=media&token=eaee1c6a-7865-4600-83cd-21c7356471e8')} style={{ cursor: 'pointer' }} />
                                        </Box>
                                        <Typography variant="h6" gutterBottom align="center">Location Tracking</Typography>
                                        <Typography color="text.secondary" align="center">Navigate to appointments seamlessly with integrated maps and directions.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                            <img src="https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fsms-demo.png?alt=media&token=ac76854e-8e85-4b64-b6d1-96a14cd8493a" width="80%" alt="SMS Demo" onClick={() => handleImageClick('https://firebasestorage.googleapis.com/v0/b/helical-client-414716.appspot.com/o/webpages-media%2Fsms-demo.png?alt=media&token=ac76854e-8e85-4b64-b6d1-96a14cd8493a')} style={{ cursor: 'pointer' }} />
                                        </Box>
                                        <Typography variant="h6" gutterBottom align="center">Communication</Typography>
                                        <Typography color="text.secondary" align="center">Stay connected with clients through our built-in messaging and notification system.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>

                    <Dialog open={open} onClose={handleClose} maxWidth="lg">
                        <DialogContent sx={{ position: 'relative', p: 0 }}>
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    bgcolor: 'rgba(255, 255, 255, 0.8)',
                                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.9)' },
                                    zIndex: 1
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <img src={selectedImage} alt="Enlarged" style={{ width: '100%', height: 'auto' }} />
                        </DialogContent>
                    </Dialog>

                    <Footer />
                </Container>
            ) : (
                <>{loader}</>
            )}
        </>
    )
}

export default ForProviderPage;
